import { sbRespNotificationUnavailableItemModalConfig } from './SbRespNotificationUnavailableItem/sbRespnotificationUnavailableItemConfig.js';

export const sbRespNotifications = [sbRespNotificationUnavailableItemModalConfig];
